export const enum UploadResultStatesEnums {
  FULFILLED = "fulfilled",
  REJECTED = "rejected",
}

export type UploadResultState =
  UploadResultStatesEnums[keyof UploadResultStatesEnums];
